import { SERVICES_STATE_CONFIG } from './services.injection-token';
import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { NgxsModule, NgxsOnInit, Selector, State, StateContext, StateToken, createSelector } from '@ngxs/store';
import { AccountWebservice } from '@wizbii-utils/angular/webservices';
import { Country, CountryService } from '@wizbii/utils/models';

export type CountryConfigStateModel = Country;
export const CountryConfigStateToken = new StateToken<CountryConfigStateModel>('countryConfig');

@State({
  name: CountryConfigStateToken,
  defaults: null,
})
@Injectable()
export class CountryConfigState implements NgxsOnInit {
  @Selector([CountryConfigStateToken])
  static config(state: CountryConfigStateModel): Country | null {
    return state;
  }

  static service(id: string): (country: Country | null) => CountryService | undefined | null {
    return createSelector(
      [CountryConfigState.config],
      (country: Country | null) => country?.services.find((service) => service.id === id)
    );
  }

  readonly #servicesConfig = inject(SERVICES_STATE_CONFIG);
  readonly #accountWebservice = inject(AccountWebservice);

  constructor() {
    if (!this.#servicesConfig.locale) {
      throw new Error('[CountryConfigState] Invalid configuration given');
    }
  }

  ngxsOnInit(ctx?: StateContext<any>): any {
    this.#accountWebservice.getServicesByCountry(this.#servicesConfig.locale).subscribe((country) => {
      ctx?.setState(country);
    });
  }
}

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([CountryConfigState])],
})
export class CountryConfigStateModule {}
